<template lang="html">
  <div>
    <vs-table
      v-model="selected"
      @selected="handleSelected"
      @dblSelection="doubleSelection"
      :data="users">
      <template slot="header">
        <h3>
          Users
        </h3>
      </template>
      <template slot="thead">
  <vs-th> Name </vs-th>
  <vs-th> Website </vs-th>
  <vs-th> Nro </vs-th>
</template>

      <template slot-scope="{data}">
  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
    <!-- <vs-td :data="data[indextr].email">
      {{ data[indextr].email }}
    </vs-td> -->

    <vs-td :data="data[indextr].username">
      {{ data[indextr].username }}
    </vs-td>

    <vs-td :data="data[indextr].website">
      {{ data[indextr].website }}
    </vs-td>

    <vs-td :data="data[indextr].id">
      {{ data[indextr].id }}
    </vs-td>
  </vs-tr>
</template>
    </vs-table>

    <pre>{{ selected }}</pre>
  </div>
</template>

<script>
export default {
  data: () => ({
    selected: [],
    users: [
      {
        id: 1,
        name: "Leanne Graham",
        username: "Bret",
        map: require("@/assets/images/background/642eca31a43110176c1ef4e5d9fee0ff.jpg"),
        sensor: [
          {
            left: 773,
            top: 116,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent1",
          },
          {
            // left: `calc( 50% - ${tW / 2}px)`,
            // top: `calc(50% - ${tH / 2}px)`,
            // height: tH,
            // width: tW,
            left: 936,
            top: 434,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent2",
          },
          {
            left: 169.75775146484375,
            top: 422.590576171875,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent3",
          },
        ],
      },
      {
        id: 2,
        name: "Ervin Howell",
        username: "Antonette",
        map: require("@/assets/images/background/1f5afb610f9531461d19b5915db22238.jpg"),
        sensor: [
          {
            left: 449,
            top: 68,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent1",
          },
          {
            // left: `calc( 50% - ${tW / 2}px)`,
            // top: `calc(50% - ${tH / 2}px)`,
            // height: tH,
            // width: tW,
            left: 625,
            top: 250,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent2",
          },
          {
            height: 0.5,
            left: 273.75775146484375,
            top: 404.590576171875,
            width: 32,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent3",
          },
        ],
      },
      {
        id: 3,
        name: "Clementine Bauch",
        username: "Samantha",
        map: require("@/assets/images/background/screen-1.jpg"),
        sensor: [
          {
            left: 449,
            top: 68,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent1",
          },
          {
            // left: `calc( 50% - ${tW / 2}px)`,
            // top: `calc(50% - ${tH / 2}px)`,
            // height: tH,
            // width: tW,
            left: 625,
            top: 250,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent2",
          },
          {
            height: 0.5,
            left: 273.75775146484375,
            top: 404.590576171875,
            width: 32,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent3",
          },
        ],
      },
      {
        id: 4,
        name: "Patricia Lebsack",
        username: "Karianne",
        map: require("@/assets/images/background/screen-1.jpg"),
        sensor: [
          {
            left: 449,
            top: 68,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent1",
          },
          {
            // left: `calc( 50% - ${tW / 2}px)`,
            // top: `calc(50% - ${tH / 2}px)`,
            // height: tH,
            // width: tW,
            left: 625,
            top: 250,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent2",
          },
          {
            height: 0.5,
            left: 273.75775146484375,
            top: 404.590576171875,
            width: 32,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent3",
          },
        ],
      },
      {
        id: 5,
        name: "Chelsey Dietrich",
        username: "Kamren",
        map: require("@/assets/images/background/screen-1.jpg"),
        sensor: [
          {
            left: 449,
            top: 68,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent1",
          },
          {
            // left: `calc( 50% - ${tW / 2}px)`,
            // top: `calc(50% - ${tH / 2}px)`,
            // height: tH,
            // width: tW,
            left: 625,
            top: 250,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent2",
          },
          {
            height: 0.5,
            left: 273.75775146484375,
            top: 404.590576171875,
            width: 32,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent3",
          },
        ],
      },
      {
        id: 6,
        name: "Mrs. Dennis Schulist",
        username: "Leopoldo_Corkery",
        map: require("@/assets/images/background/screen-1.jpg"),
        sensor: [
          {
            left: 449,
            top: 68,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent1",
          },
          {
            // left: `calc( 50% - ${tW / 2}px)`,
            // top: `calc(50% - ${tH / 2}px)`,
            // height: tH,
            // width: tW,
            left: 625,
            top: 250,
            width: 32,
            height: 0.5,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent2",
          },
          {
            height: 0.5,
            left: 273.75775146484375,
            top: 404.590576171875,
            width: 32,
            fit: true,
            event: "",
            dragSelector: ".drag-container-1, .drag-container-2",
            ref: "resizableComponent3",
          },
        ],
      },
    ],
  }),
  methods: {
    handleSelected(tr) {
      this.$vs.notify({
        title: `Selected ${tr.username}`,
      });
      // this.$session.set("branch_code", item[0].branch_code);
      this.$session.set("data", tr);
      this.$router.push({
        path: "/test2",
        params: { data: tr },
      });
    },
    doubleSelection(tr) {
      this.$vs.notify({
        title: `Double Selection ${tr.username}`,
        text: `Email: ${tr.email}`,
        color: "success",
      });
    },
  },
};
</script>